import { Action } from 'redux';

import { IContentInfo } from '../../../ts/models/IContentInfo';
import { DeleteContents, DeleteContentsSucceeded } from '../AppActionTypes';
import { isActionFactory } from '../isActionFactory';

export interface DeleteContentAction extends Action {
  contentArray: IContentInfo[];
}

export function deleteContentsAction(contentArray: IContentInfo[]): DeleteContentAction {
  return {
    type: DeleteContents,
    contentArray: contentArray
  };
}

export function deleteContentAction(content: IContentInfo): DeleteContentAction {
  return deleteContentsAction([content]);
}

export const isDeleteContentAction = isActionFactory<DeleteContentAction>(DeleteContents);

export interface DeleteContentSucceededAction extends Action {}

export function deleteContentSucceeded(): DeleteContentSucceededAction {
  return {
    type: DeleteContentsSucceeded
  };
}

export const isDeleteContentSucceeded = isActionFactory<DeleteContentSucceededAction>(DeleteContentsSucceeded);
